import { u, styled } from '../../../../shared/theming-sc'
import PrimaryButton from '../../../primary-button/PrimaryButton'

const FooterLink = styled.a`
    cursor: pointer;
    color:${u.getColor('greyDark')};
    font-size: ${u.getFontSize('md')};
    font-weight: 600;
    text-decoration: underline;
`

const FooterForm = styled.div`
    float: right;

    input {
        margin-right: ${u.getSpacing('tiny')}px;
    }
`

const StyledApplyButton = styled(PrimaryButton)`
    float: right;
    position: relative;
    top: -${u.getSpacing('small')}px;
    margin-left: ${u.getSpacing('small')}px;
    
    ${u.media.greaterThan('sm')`
       margin-left: ${u.getSpacing('large')}px;
    `};
`

const FooterFilterlabelWrapper = styled.div`
    display: inline-block;
`

export {
  StyledApplyButton,
  FooterForm,
  FooterLink,
  FooterFilterlabelWrapper
}
